document.addEventListener("DOMContentLoaded", () => {
    const gallery = document.querySelector("media-carousel");
    if (!gallery) return;

    const firstMedia = gallery.querySelector(".product-gallery__media:first-child");
    if (!firstMedia) return;
    
    const firstImage = firstMedia.querySelector("img");
    if (!firstImage) return;

    const originalSrc = firstImage.currentSrc || firstImage.src;
    let secondImageOriginalSrc = null;
    let secondMediaElement = null;
    
    const allMedia = gallery.querySelectorAll(".product-gallery__media");
    if (allMedia.length > 1) {
        secondMediaElement = allMedia[1];
        const secondImg = secondMediaElement.querySelector("img");
        if (secondImg) {
            secondImageOriginalSrc = secondImg.currentSrc || secondImg.src;
        }
    }

    // Store original thumbnail sources
    let thumbnailOriginalSrcs = [];
    const allThumbnails = document.querySelectorAll(".product-gallery__thumbnail");
    allThumbnails.forEach((thumb, index) => {
        const img = thumb.querySelector("img");
        if (img) {
            thumbnailOriginalSrcs[index] = img.currentSrc || img.src;
        }
    });

    // First image replacement map - UPDATED with corrected color names
    const firstImageReplacementMap = {
        'Pure Linen_Wit #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/norsemaison_linnen_gordijnen_purelinenwhite2.jpg?v=1785783016',
        'Pure Linen_White #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/norsemaison_linnen_gordijnen_purelinenwhite2.jpg?v=1785783016',
        'Pure Linen_Blanc #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/norsemaison_linnen_gordijnen_purelinenwhite2.jpg?v=1785783016',
        'Pure Linen_Weiß #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/norsemaison_linnen_gordijnen_purelinenwhite2.jpg?v=1785783016',
        'Pure Linen_Bianco #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/norsemaison_linnen_gordijnen_purelinenwhite2.jpg?v=1785783016',
        'Pure Linen_Blanco #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/norsemaison_linnen_gordijnen_purelinenwhite2.jpg?v=1785783016',
        'Pure Linen_Beige #2': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Pure_Linnen_Beige-pichi.jpg?v=1785784918',
        'Pure Linen_Olijf #4': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Pure-Linnen-Olijf-pichi.jpg?v=1772455251',
        'Pure Linen_Olive #4': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Pure-Linnen-Olijf-pichi.jpg?v=1772455251',
        'Pure Linen_Oliv #4': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Pure-Linnen-Olijf-pichi.jpg?v=1772455251',
        'Pure Linen_Oliva #4': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Pure-Linnen-Olijf-pichi.jpg?v=1772455251',
        'Palermo_Gebroken Wit #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-1V2.jpg?v=1785785035',
        'Palermo_Off-White #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-1V2.jpg?v=1785785035',
        'Palermo_Blanc cassé #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-1V2.jpg?v=1785785035',
        'Palermo_Cremeweiß #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-1V2.jpg?v=1785785035',
        'Palermo_Bianco sporco #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-1V2.jpg?v=1785785035',
        'Palermo_Blanco roto #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-1V2.jpg?v=1785785035',
        'Palermo_Zand #2': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-2V1.jpg?v=1785785068',
        'Palermo_Sand #2': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-2V1.jpg?v=1785785068',
        'Palermo_Sable #2': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-2V1.jpg?v=1785785068',
        'Palermo_Sabbia #2': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-2V1.jpg?v=1785785068',
        'Palermo_Arena #2': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-2V1.jpg?v=1785785068',
        'Palermo_Mokka #5': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-5V2.jpg?v=1785785120',
        'Palermo_Mocha #5': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-5V2.jpg?v=1785785120',
        'Palermo_Moka #5': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-5V2.jpg?v=1785785120',
        'Palermo_Moca #5': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-5V2.jpg?v=1785785120',
        'Palermo_Grijsblauw #25': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-25V2.jpg?v=1765179012',
        'Palermo_Gray Blue #25': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-25V2.jpg?v=1765179012',
        'Palermo_Bleu gris #25': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-25V2.jpg?v=1765179012',
        'Palermo_Graublau #25': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-25V2.jpg?v=1765179012',
        'Palermo_Blu grigiastro #25': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-25V2.jpg?v=1765179012',
        'Palermo_Azul grisáceo #25': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-25V2.jpg?v=1765179012',
        'Marseille_Compact Beige #3': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Provence-Elegance_61720586362_-kopie.pic-pichi.jpg?v=1772455251',
        'Marseille_Beige compact #3': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Provence-Elegance_61720586362_-kopie.pic-pichi.jpg?v=1772455251',
        'Marseille_Kompaktes Beige #3': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Provence-Elegance_61720586362_-kopie.pic-pichi.jpg?v=1772455251',
        'Marseille_Beige compatto #3': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Provence-Elegance_61720586362_-kopie.pic-pichi.jpg?v=1772455251',
        'Marseille_Beige compacto #3': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Provence-Elegance_61720586362_-kopie.pic-pichi.jpg?v=1772455251',
        
        'Evora_Beige #6': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Evora-Beige-6_1-pichi.jpg?v=1785785343',
        'Evora_Mint #2': 'https://www.norsemaison.com/cdn/shop/files/Evora-MS001-2-pichi.jpg?v=1772454945',
        'Evora_Munt #2': 'https://www.norsemaison.com/cdn/shop/files/Evora-MS001-2-pichi.jpg?v=1772454945',
        'Evora_Minz #2': 'https://www.norsemaison.com/cdn/shop/files/Evora-MS001-2-pichi.jpg?v=1772454945',
        'Evora_Minze #2': 'https://www.norsemaison.com/cdn/shop/files/Evora-MS001-2-pichi.jpg?v=1772454945',
        'Elegance Vitrage_Zand #11': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Elegance-Vitrage-Photo-11-pichi_0a63eb99-113d-40c7-aca6-3d28de2d0dfe.jpg?v=1785785425',
        'Elegance Vitrage_Sand #11': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Elegance-Vitrage-Photo-11-pichi_0a63eb99-113d-40c7-aca6-3d28de2d0dfe.jpg?v=1785785425',
        'Elegance Vitrage_Sable #11': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Elegance-Vitrage-Photo-11-pichi_0a63eb99-113d-40c7-aca6-3d28de2d0dfe.jpg?v=1785785425',
        'Elegance Vitrage_Sabbia #11': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Elegance-Vitrage-Photo-11-pichi_0a63eb99-113d-40c7-aca6-3d28de2d0dfe.jpg?v=1785785425',
        'Elegance Vitrage_Arena #11': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Elegance-Vitrage-Photo-11-pichi_0a63eb99-113d-40c7-aca6-3d28de2d0dfe.jpg?v=1785785425',
        'Elegance Vitrage_Beige #16': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Elegance_Vitrage_Beige_16-4.jpg?v=1772455251',
        'Elegance Vitrage_Taupe #12': 'http://www.norsemaison.com/cdn/shop/files/Elegance-12-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Tortora #12': 'http://www.norsemaison.com/cdn/shop/files/Elegance-12-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Mint #4': 'https://www.norsemaison.com/cdn/shop/files/8000-4-Mint-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Minz #4': 'https://www.norsemaison.com/cdn/shop/files/8000-4-Mint-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Minze #4': 'https://www.norsemaison.com/cdn/shop/files/8000-4-Mint-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Munt #4': 'https://www.norsemaison.com/cdn/shop/files/8000-4-Mint-scaled_new.jpg?v=1772454945',
        'Milano Vitrage_Taupe': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Milano-vitrage-curtain_368552938F73-1-pichi.jpg?v=1759762338',
        'Milano Vitrage_Tortora': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Milano-vitrage-curtain_368552938F73-1-pichi.jpg?v=1759762338',
        'Milano Vitrage_Topo': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Milano-vitrage-curtain_368552938F73-1-pichi.jpg?v=1759762338',
        'Milano Vitrage_Wit': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Milano-white-curtains.jpg?v=1785943540',
        'Milano Vitrage_White': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Milano-white-curtains.jpg?v=1785943540',
        'Milano Vitrage_Blanc': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Milano-white-curtains.jpg?v=1785943540',
        'Milano Vitrage_Weiß': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Milano-white-curtains.jpg?v=1785943540',
        'Milano Vitrage_Bianco': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Milano-white-curtains.jpg?v=1785943540',
        'Milano Vitrage_Blanco': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Milano-white-curtains.jpg?v=1785943540',
    };

    // Second image replacement map - uses swatch images for the second slide
    const secondImageReplacementMap = {
        // Pure Linen - Dutch
        'Pure Linen_Wit #1': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-1-1_4203223e-922f-4f09-970c-330fec12c7bc.jpg?v=1772454726',
        'Pure Linen_Beige #2': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-2_148943bb-64ff-4658-bda4-44b3cad497ee.jpg?v=1772454726',
        'Pure Linen_Lichtgrijs #3': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-3.jpg?v=1772454945',
        'Pure Linen_Olijf #4': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-4.jpg?v=1772454945',
        // Pure Linen - English
        'Pure Linen_White #1': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-1-1_4203223e-922f-4f09-970c-330fec12c7bc.jpg?v=1772454726',
        'Pure Linen_Beige #2': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-2_148943bb-64ff-4658-bda4-44b3cad497ee.jpg?v=1772454726',
        'Pure Linen_Light gray #3': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-3.jpg?v=1772454945',
        'Pure Linen_Olive #4': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-4.jpg?v=1772454945',
        // Pure Linen - French
        'Pure Linen_Blanc #1': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-1-1_4203223e-922f-4f09-970c-330fec12c7bc.jpg?v=1772454726',
        'Pure Linen_Beige #2': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-2_148943bb-64ff-4658-bda4-44b3cad497ee.jpg?v=1772454726',
        'Pure Linen_Gris clair #3': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-3.jpg?v=1772454945',
        'Pure Linen_Olive #4': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-4.jpg?v=1772454945',
        // Pure Linen - German
        'Pure Linen_Weiß #1': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-1-1_4203223e-922f-4f09-970c-330fec12c7bc.jpg?v=1772454726',
        'Pure Linen_Beige #2': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-2_148943bb-64ff-4658-bda4-44b3cad497ee.jpg?v=1772454726',
        'Pure Linen_Hellgrau #3': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-3.jpg?v=1772454945',
        'Pure Linen_Oliv #4': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-4.jpg?v=1772454945',
        // Pure Linen - Italian
        'Pure Linen_Bianco #1': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-1-1_4203223e-922f-4f09-970c-330fec12c7bc.jpg?v=1772454726',
        'Pure Linen_Beige #2': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-2_148943bb-64ff-4658-bda4-44b3cad497ee.jpg?v=1772454726',
        'Pure Linen_Grigio chiaro #3': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-3.jpg?v=1772454945',
        'Pure Linen_Oliva #4': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-4.jpg?v=1772454945',
        // Pure Linen - Spanish
        'Pure Linen_Blanco #1': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-1-1_4203223e-922f-4f09-970c-330fec12c7bc.jpg?v=1772454726',
        'Pure Linen_Beige #2': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-2_148943bb-64ff-4658-bda4-44b3cad497ee.jpg?v=1772454726',
        'Pure Linen_Gris claro #3': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-3.jpg?v=1772454945',
        'Pure Linen_Oliva #4': '//www.norsemaison.com/cdn/shop/files/Pure-Linen-4.jpg?v=1772454945',

        // Palermo - Dutch
        'Palermo_Palermo - Gebroken Wit #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-wit-0_a16aad41-16e2-42f1-a5e3-c4160bdff05c.jpg?v=1787840608',
        'Palermo_Gebroken Wit #1': '//www.norsemaison.com/cdn/shop/files/Palermo-1_f1fc78f2-8953-453f-b4f0-93ef7a2e2703.jpg?v=1772454726',
        'Palermo_Zand #2': '//www.norsemaison.com/cdn/shop/files/Palermo-2.jpg?v=1772454945',
        'Palermo_Beige #3': '//www.norsemaison.com/cdn/shop/files/Palermo-3.jpg?v=1772454945',
        'Palermo_Mokka #5': '//www.norsemaison.com/cdn/shop/files/Palermo-5.jpg?v=1772454945',
        'Palermo_Grijsbruin #19': '//www.norsemaison.com/cdn/shop/files/Palermo-19.jpg?v=1772454945',
        'Palermo_Olijf #20': '//www.norsemaison.com/cdn/shop/files/Palermo-20.jpg?v=1772454945',
        'Palermo_Bruin #24': '//www.norsemaison.com/cdn/shop/files/Palermo-24.jpg?v=1772454945',
        'Palermo_Grijsblauw #25': '//www.norsemaison.com/cdn/shop/files/Palermo-25.jpg?v=1772454945',
        // Palermo - English
        'Palermo_Palermo - Off-White #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-wit-0_a16aad41-16e2-42f1-a5e3-c4160bdff05c.jpg?v=1787840608',
        'Palermo_Off-White #1': '//www.norsemaison.com/cdn/shop/files/Palermo-1_f1fc78f2-8953-453f-b4f0-93ef7a2e2703.jpg?v=1772454726',
        'Palermo_Sand #2': '//www.norsemaison.com/cdn/shop/files/Palermo-2.jpg?v=1772454945',
        'Palermo_Beige #3': '//www.norsemaison.com/cdn/shop/files/Palermo-3.jpg?v=1772454945',
        'Palermo_Mocha #5': '//www.norsemaison.com/cdn/shop/files/Palermo-5.jpg?v=1772454945',
        'Palermo_Gray Brown #19': '//www.norsemaison.com/cdn/shop/files/Palermo-19.jpg?v=1772454945',
        'Palermo_Olive #20': '//www.norsemaison.com/cdn/shop/files/Palermo-20.jpg?v=1772454945',
        'Palermo_Brown #24': '//www.norsemaison.com/cdn/shop/files/Palermo-24.jpg?v=1772454945',
        'Palermo_Gray Blue #25': '//www.norsemaison.com/cdn/shop/files/Palermo-25.jpg?v=1772454945',
        // Palermo - French
        'Palermo_Palermo - Blanc cassé #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-wit-0_a16aad41-16e2-42f1-a5e3-c4160bdff05c.jpg?v=1787840608',
        'Palermo_Blanc cassé #1': '//www.norsemaison.com/cdn/shop/files/Palermo-1_f1fc78f2-8953-453f-b4f0-93ef7a2e2703.jpg?v=1772454726',
        'Palermo_Sable #2': '//www.norsemaison.com/cdn/shop/files/Palermo-2.jpg?v=1772454945',
        'Palermo_Beige #3': '//www.norsemaison.com/cdn/shop/files/Palermo-3.jpg?v=1772454945',
        'Palermo_Moka #5': '//www.norsemaison.com/cdn/shop/files/Palermo-5.jpg?v=1772454945',
        'Palermo_Brun gris #19': '//www.norsemaison.com/cdn/shop/files/Palermo-19.jpg?v=1772454945',
        'Palermo_Olive #20': '//www.norsemaison.com/cdn/shop/files/Palermo-20.jpg?v=1772454945',
        'Palermo_Brun #24': '//www.norsemaison.com/cdn/shop/files/Palermo-24.jpg?v=1772454945',
        'Palermo_Bleu gris #25': '//www.norsemaison.com/cdn/shop/files/Palermo-25.jpg?v=1772454945',
        // Palermo - German
        'Palermo_Palermo - Cremeweiß #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-wit-0_a16aad41-16e2-42f1-a5e3-c4160bdff05c.jpg?v=1787840608',
        'Palermo_Cremeweiß #1': '//www.norsemaison.com/cdn/shop/files/Palermo-1_f1fc78f2-8953-453f-b4f0-93ef7a2e2703.jpg?v=1772454726',
        'Palermo_Sand #2': '//www.norsemaison.com/cdn/shop/files/Palermo-2.jpg?v=1772454945',
        'Palermo_Beige #3': '//www.norsemaison.com/cdn/shop/files/Palermo-3.jpg?v=1772454945',
        'Palermo_Mokka #5': '//www.norsemaison.com/cdn/shop/files/Palermo-5.jpg?v=1772454945',
        'Palermo_Graubraun #19': '//www.norsemaison.com/cdn/shop/files/Palermo-19.jpg?v=1772454945',
        'Palermo_Oliv #20': '//www.norsemaison.com/cdn/shop/files/Palermo-20.jpg?v=1772454945',
        'Palermo_Braun #24': '//www.norsemaison.com/cdn/shop/files/Palermo-24.jpg?v=1772454945',
        'Palermo_Graublau #25': '//www.norsemaison.com/cdn/shop/files/Palermo-25.jpg?v=1772454945',
        // Palermo - Italian
        'Palermo_Palermo - Bianco sporco #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-wit-0_a16aad41-16e2-42f1-a5e3-c4160bdff05c.jpg?v=1787840608',
        'Palermo_Bianco sporco #1': '//www.norsemaison.com/cdn/shop/files/Palermo-1_f1fc78f2-8953-453f-b4f0-93ef7a2e2703.jpg?v=1772454726',
        'Palermo_Sabbia #2': '//www.norsemaison.com/cdn/shop/files/Palermo-2.jpg?v=1772454945',
        'Palermo_Beige #3': '//www.norsemaison.com/cdn/shop/files/Palermo-3.jpg?v=1772454945',
        'Palermo_Moka #5': '//www.norsemaison.com/cdn/shop/files/Palermo-5.jpg?v=1772454945',
        'Palermo_Marrone grigiastro #19': '//www.norsemaison.com/cdn/shop/files/Palermo-19.jpg?v=1772454945',
        'Palermo_Oliva #20': '//www.norsemaison.com/cdn/shop/files/Palermo-20.jpg?v=1772454945',
        'Palermo_Marrone #24': '//www.norsemaison.com/cdn/shop/files/Palermo-24.jpg?v=1772454945',
        'Palermo_Blu grigiastro #25': '//www.norsemaison.com/cdn/shop/files/Palermo-25.jpg?v=1772454945',
        // Palermo - Spanish
        'Palermo_Palermo - Blanco roto #1': 'https://cdn.shopify.com/s/files/1/0951/0561/4167/files/Palermo-wit-0_a16aad41-16e2-42f1-a5e3-c4160bdff05c.jpg?v=1787840608',
        'Palermo_Blanco roto #1': '//www.norsemaison.com/cdn/shop/files/Palermo-1_f1fc78f2-8953-453f-b4f0-93ef7a2e2703.jpg?v=1772454726',
        'Palermo_Arena #2': '//www.norsemaison.com/cdn/shop/files/Palermo-2.jpg?v=1772454945',
        'Palermo_Beige #3': '//www.norsemaison.com/cdn/shop/files/Palermo-3.jpg?v=1772454945',
        'Palermo_Moca #5': '//www.norsemaison.com/cdn/shop/files/Palermo-5.jpg?v=1772454945',
        'Palermo_Marrón grisáceo #19': '//www.norsemaison.com/cdn/shop/files/Palermo-19.jpg?v=1772454945',
        'Palermo_Oliva #20': '//www.norsemaison.com/cdn/shop/files/Palermo-20.jpg?v=1772454945',
        'Palermo_Marrón #24': '//www.norsemaison.com/cdn/shop/files/Palermo-24.jpg?v=1772454945',
        'Palermo_Azul grisáceo #25': '//www.norsemaison.com/cdn/shop/files/Palermo-25.jpg?v=1772454945',

        // Marseille
        'Marseille_Compact Beige #3': '//www.norsemaison.com/cdn/shop/files/Marseille-3.jpg?v=1772454945',
        'Marseille_Ivoor met Blauwe Streep #17': '//www.norsemaison.com/cdn/shop/files/Marseille-17.jpg?v=1772454945',
        'Marseille_Beige compact #3': '//www.norsemaison.com/cdn/shop/files/Marseille-3.jpg?v=1772454945',
        'Marseille_Ivoire avec rayure bleue #17': '//www.norsemaison.com/cdn/shop/files/Marseille-17.jpg?v=1772454945',
        'Marseille_Kompaktes Beige #3': '//www.norsemaison.com/cdn/shop/files/Marseille-3.jpg?v=1772454945',
        'Marseille_Elfenbein mit blauem Streifen #17': '//www.norsemaison.com/cdn/shop/files/Marseille-17.jpg?v=1772454945',
        'Marseille_Beige compatto #3': '//www.norsemaison.com/cdn/shop/files/Marseille-3.jpg?v=1772454945',
        'Marseille_Avorio con striscia blu #17': '//www.norsemaison.com/cdn/shop/files/Marseille-17.jpg?v=1772454945',
        'Marseille_Beige compacto #3': '//www.norsemaison.com/cdn/shop/files/Marseille-3.jpg?v=1772454945',
        'Marseille_Marfil con raya azul #17': '//www.norsemaison.com/cdn/shop/files/Marseille-17.jpg?v=1772454945',
        // English - Marseille
        'Marseille_Ivory with Blue Stripe #17': '//www.norsemaison.com/cdn/shop/files/Marseille-17.jpg?v=1772454945',

        // Evora
        'Evora_Bruin #1': '//www.norsemaison.com/cdn/shop/files/Evora-MS001-1-pichi.jpg?v=1772454945',
        'Evora_Mint #2': '//www.norsemaison.com/cdn/shop/files/Evora-MS001-2-pichi.jpg?v=1772454945',
        'Evora_Munt #2': '//www.norsemaison.com/cdn/shop/files/Evora-MS001-2-pichi.jpg?v=1772454945',
        'Evora_Minz #2': '//www.norsemaison.com/cdn/shop/files/Evora-MS001-2-pichi.jpg?v=1772454945',
        'Evora_Olijf #4': '//www.norsemaison.com/cdn/shop/files/Evora-MS001-4-pichi.jpg?v=1772454945',
        'Evora_Beige #6': '//www.norsemaison.com/cdn/shop/files/Evora-MS001-6-pichi.jpg?v=1772454945',
        'Evora_Brown #1': '//www.norsemaison.com/cdn/shop/files/Evora-MS001-1-pichi.jpg?v=1772454945',
        'Evora_Olive #4': '//www.norsemaison.com/cdn/shop/files/Evora-MS001-4-pichi.jpg?v=1772454945',
        'Evora_Brun #1': '//www.norsemaison.com/cdn/shop/files/Evora-MS001-1-pichi.jpg?v=1772454945',
        'Evora_Menthe #2': '//www.norsemaison.com/cdn/shop/files/Evora-MS001-2-pichi.jpg?v=1772454945',
        'Evora_Braun #1': '//www.norsemaison.com/cdn/shop/files/Evora-MS001-1-pichi.jpg?v=1772454945',
        'Evora_Oliv #4': '//www.norsemaison.com/cdn/shop/files/Evora-MS001-4-pichi.jpg?v=1772454945',
        'Evora_Marrone #1': '//www.norsemaison.com/cdn/shop/files/Evora-MS001-1-pichi.jpg?v=1772454945',
        'Evora_Menta #2': '//www.norsemaison.com/cdn/shop/files/Evora-MS001-2-pichi.jpg?v=1772454945',
        'Evora_Oliva #4': '//www.norsemaison.com/cdn/shop/files/Evora-MS001-4-pichi.jpg?v=1772454945',
        'Evora_Marrón #1': '//www.norsemaison.com/cdn/shop/files/Evora-MS001-1-pichi.jpg?v=1772454945',

        // Elegance Vitrage
        'Elegance Vitrage_Wit #1': '//www.norsemaison.com/cdn/shop/files/8000-1-pichi.jpg?v=1772454945',
        'Elegance Vitrage_Mint #4': '//www.norsemaison.com/cdn/shop/files/8000-4-Mint-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Munt #4': '//www.norsemaison.com/cdn/shop/files/8000-4-Mint-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Minz #4': '//www.norsemaison.com/cdn/shop/files/8000-4-Mint-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Lichtblauw #5': '//www.norsemaison.com/cdn/shop/files/8000-5-Licht-Turqoise-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Zeeblauw #7': '//www.norsemaison.com/cdn/shop/files/Elegance-7-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Zand #11': '//www.norsemaison.com/cdn/shop/files/8000-11-Zand-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Taupe #12': '//www.norsemaison.com/cdn/shop/files/Elegance-12-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Tortora #12': '//www.norsemaison.com/cdn/shop/files/Elegance-12-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Kiezelgrijs #13': '//www.norsemaison.com/cdn/shop/files/Elegance-13-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Cappuccino #14': '//www.norsemaison.com/cdn/shop/files/Elegance-14-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Beige #16': '//www.norsemaison.com/cdn/shop/files/Elegance-16-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Mosterd #19': '//www.norsemaison.com/cdn/shop/files/Elegance-19-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Licht Turquoise #': '//www.norsemaison.com/cdn/shop/files/Elegance-21-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Roze #22': '//www.norsemaison.com/cdn/shop/files/Elegance-22-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Framboos #23': '//www.norsemaison.com/cdn/shop/files/Elegance-23-NEW.jpg?v=1772454945',
        // Elegance Vitrage - English
        'Elegance Vitrage_White #1': '//www.norsemaison.com/cdn/shop/files/8000-1-pichi.jpg?v=1772454945',
        'Elegance Vitrage_Light Blue #5': '//www.norsemaison.com/cdn/shop/files/8000-5-Licht-Turqoise-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Sea Blue #7': '//www.norsemaison.com/cdn/shop/files/Elegance-7-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Sand #11': '//www.norsemaison.com/cdn/shop/files/8000-11-Zand-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Pebble Gray #13': '//www.norsemaison.com/cdn/shop/files/Elegance-13-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Mustard #19': '//www.norsemaison.com/cdn/shop/files/Elegance-19-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Light Turquoise #': '//www.norsemaison.com/cdn/shop/files/Elegance-21-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Pink #22': '//www.norsemaison.com/cdn/shop/files/Elegance-22-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Raspberry #23': '//www.norsemaison.com/cdn/shop/files/Elegance-23-NEW.jpg?v=1772454945',
        // Elegance Vitrage - French
        'Elegance Vitrage_Blanc #1': '//www.norsemaison.com/cdn/shop/files/8000-1-pichi.jpg?v=1772454945',
        'Elegance Vitrage_Menthe #4': '//www.norsemaison.com/cdn/shop/files/8000-4-Mint-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Bleu clair #5': '//www.norsemaison.com/cdn/shop/files/8000-5-Licht-Turqoise-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Bleu mer #7': '//www.norsemaison.com/cdn/shop/files/Elegance-7-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Sable #11': '//www.norsemaison.com/cdn/shop/files/8000-11-Zand-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Gris galet #13': '//www.norsemaison.com/cdn/shop/files/Elegance-13-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Moutarde #19': '//www.norsemaison.com/cdn/shop/files/Elegance-19-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Turquoise clair #': '//www.norsemaison.com/cdn/shop/files/Elegance-21-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Rose #22': '//www.norsemaison.com/cdn/shop/files/Elegance-22-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Framboise #23': '//www.norsemaison.com/cdn/shop/files/Elegance-23-NEW.jpg?v=1772454945',
        // Elegance Vitrage - German
        'Elegance Vitrage_Weiß #1': '//www.norsemaison.com/cdn/shop/files/8000-1-pichi.jpg?v=1772454945',
        'Elegance Vitrage_Hellblau #5': '//www.norsemaison.com/cdn/shop/files/8000-5-Licht-Turqoise-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Meerblau #7': '//www.norsemaison.com/cdn/shop/files/Elegance-7-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Sand #11': '//www.norsemaison.com/cdn/shop/files/8000-11-Zand-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Kieselgrau #13': '//www.norsemaison.com/cdn/shop/files/Elegance-13-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Senf #19': '//www.norsemaison.com/cdn/shop/files/Elegance-19-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Helltürkis #': '//www.norsemaison.com/cdn/shop/files/Elegance-21-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Rosa #22': '//www.norsemaison.com/cdn/shop/files/Elegance-22-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Himbeere #23': '//www.norsemaison.com/cdn/shop/files/Elegance-23-NEW.jpg?v=1772454945',
        // Elegance Vitrage - Italian
        'Elegance Vitrage_Bianco #1': '//www.norsemaison.com/cdn/shop/files/8000-1-pichi.jpg?v=1772454945',
        'Elegance Vitrage_Menta #4': '//www.norsemaison.com/cdn/shop/files/8000-4-Mint-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Azzurro #5': '//www.norsemaison.com/cdn/shop/files/8000-5-Licht-Turqoise-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Blu mare #7': '//www.norsemaison.com/cdn/shop/files/Elegance-7-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Sabbia #11': '//www.norsemaison.com/cdn/shop/files/8000-11-Zand-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Grigio ciottolo #13': '//www.norsemaison.com/cdn/shop/files/Elegance-13-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Senape #19': '//www.norsemaison.com/cdn/shop/files/Elegance-19-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Turchese chiaro #': '//www.norsemaison.com/cdn/shop/files/Elegance-21-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Lampone #23': '//www.norsemaison.com/cdn/shop/files/Elegance-23-NEW.jpg?v=1772454945',
        // Elegance Vitrage - Spanish
        'Elegance Vitrage_Blanco #1': '//www.norsemaison.com/cdn/shop/files/8000-1-pichi.jpg?v=1772454945',
        'Elegance Vitrage_Azul claro #5': '//www.norsemaison.com/cdn/shop/files/8000-5-Licht-Turqoise-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Azul mar #7': '//www.norsemaison.com/cdn/shop/files/Elegance-7-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Arena #11': '//www.norsemaison.com/cdn/shop/files/8000-11-Zand-scaled_new.jpg?v=1772454945',
        'Elegance Vitrage_Topo #12': '//www.norsemaison.com/cdn/shop/files/Elegance-12-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Gris guijarro #13': '//www.norsemaison.com/cdn/shop/files/Elegance-13-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Capuchino #14': '//www.norsemaison.com/cdn/shop/files/Elegance-14-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Mostaza #19': '//www.norsemaison.com/cdn/shop/files/Elegance-19-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Turquesa claro #': '//www.norsemaison.com/cdn/shop/files/Elegance-21-NEW.jpg?v=1772454945',
        'Elegance Vitrage_Frambuesa #23': '//www.norsemaison.com/cdn/shop/files/Elegance-23-NEW.jpg?v=1772454945',

        // Milano Vitrage
        'Milano Vitrage_Wit': '//www.norsemaison.com/cdn/shop/files/Milano-vitrage-curtain-2025-06-20-17-40-51-8-pichi-768x786.jpg?v=1764701796',
        'Milano Vitrage_Taupe': '//www.norsemaison.com/cdn/shop/files/Milano-vitrage-curtain_C49346FFEA6A-2-pichi-1-pichi-768x809_61d4836d-947b-4e65-a6bf-ba38c086a99e.jpg?v=1764701822',
        'Milano Vitrage_Tortora': '//www.norsemaison.com/cdn/shop/files/Milano-vitrage-curtain_C49346FFEA6A-2-pichi-1-pichi-768x809_61d4836d-947b-4e65-a6bf-ba38c086a99e.jpg?v=1764701822',
        'Milano Vitrage_Topo': '//www.norsemaison.com/cdn/shop/files/Milano-vitrage-curtain_C49346FFEA6A-2-pichi-1-pichi-768x809_61d4836d-947b-4e65-a6bf-ba38c086a99e.jpg?v=1764701822',
        'Milano Vitrage_White': '//www.norsemaison.com/cdn/shop/files/Milano-vitrage-curtain-2025-06-20-17-40-51-8-pichi-768x786.jpg?v=1764701796',
        'Milano Vitrage_Blanc': '//www.norsemaison.com/cdn/shop/files/Milano-vitrage-curtain-2025-06-20-17-40-51-8-pichi-768x786.jpg?v=1764701796',
        'Milano Vitrage_Weiß': '//www.norsemaison.com/cdn/shop/files/Milano-vitrage-curtain-2025-06-20-17-40-51-8-pichi-768x786.jpg?v=1764701796',
        'Milano Vitrage_Bianco': '//www.norsemaison.com/cdn/shop/files/Milano-vitrage-curtain-2025-06-20-17-40-51-8-pichi-768x786.jpg?v=1764701796',
        'Milano Vitrage_Blanco': '//www.norsemaison.com/cdn/shop/files/Milano-vitrage-curtain-2025-06-20-17-40-51-8-pichi-768x786.jpg?v=1764701796',

        // Luna Verduistering
        'Luna Verduistering_Grijs #5': '//www.norsemaison.com/cdn/shop/files/Luna-5.jpg?v=1772454945',
        'Luna Verduistering_Lichtgrijs #7': '//www.norsemaison.com/cdn/shop/files/Luna-7.jpg?v=1772454945',
        'Luna Verduistering_Ivoor #9': '//www.norsemaison.com/cdn/shop/files/Luna-9-1.jpg?v=1772454945',
        'Luna Verduistering_Beige #10': '//www.norsemaison.com/cdn/shop/files/Luna-10.jpg?v=1772454945',
        'Luna Verduistering_Zand #11': '//www.norsemaison.com/cdn/shop/files/Luna-11.jpg?v=1772454945',
        'Luna Verduistering_Mokka #12': '//www.norsemaison.com/cdn/shop/files/Luna-12.jpg?v=1772454945',
        'Luna Verduistering_Blauw #19': '//www.norsemaison.com/cdn/shop/files/Luna-19.jpg?v=1772454945',
        'Luna Verduistering_Zwart #21': '//www.norsemaison.com/cdn/shop/files/Luna-21.jpg?v=1772454945',
        'Luna Verduistering_Gray #5': '//www.norsemaison.com/cdn/shop/files/Luna-5.jpg?v=1772454945',
        'Luna Verduistering_Light Gray #7': '//www.norsemaison.com/cdn/shop/files/Luna-7.jpg?v=1772454945',
        'Luna Verduistering_Ivory #9': '//www.norsemaison.com/cdn/shop/files/Luna-9-1.jpg?v=1772454945',
        'Luna Verduistering_Sand #11': '//www.norsemaison.com/cdn/shop/files/Luna-11.jpg?v=1772454945',
        'Luna Verduistering_Mocha #12': '//www.norsemaison.com/cdn/shop/files/Luna-12.jpg?v=1772454945',
        'Luna Verduistering_Blue #19': '//www.norsemaison.com/cdn/shop/files/Luna-19.jpg?v=1772454945',
        'Luna Verduistering_Black #21': '//www.norsemaison.com/cdn/shop/files/Luna-21.jpg?v=1772454945',
        'Luna Verduistering_Gris #5': '//www.norsemaison.com/cdn/shop/files/Luna-5.jpg?v=1772454945',
        'Luna Verduistering_Gris clair #7': '//www.norsemaison.com/cdn/shop/files/Luna-7.jpg?v=1772454945',
        'Luna Verduistering_Ivoire #9': '//www.norsemaison.com/cdn/shop/files/Luna-9-1.jpg?v=1772454945',
        'Luna Verduistering_Sable #11': '//www.norsemaison.com/cdn/shop/files/Luna-11.jpg?v=1772454945',
        'Luna Verduistering_Moka #12': '//www.norsemaison.com/cdn/shop/files/Luna-12.jpg?v=1772454945',
        'Luna Verduistering_Bleu #19': '//www.norsemaison.com/cdn/shop/files/Luna-19.jpg?v=1772454945',
        'Luna Verduistering_Noir #21': '//www.norsemaison.com/cdn/shop/files/Luna-21.jpg?v=1772454945',
        'Luna Verduistering_Grau #5': '//www.norsemaison.com/cdn/shop/files/Luna-5.jpg?v=1772454945',
        'Luna Verduistering_Hellgrau #7': '//www.norsemaison.com/cdn/shop/files/Luna-7.jpg?v=1772454945',
        'Luna Verduistering_Elfenbein #9': '//www.norsemaison.com/cdn/shop/files/Luna-9-1.jpg?v=1772454945',
        'Luna Verduistering_Blau #19': '//www.norsemaison.com/cdn/shop/files/Luna-19.jpg?v=1772454945',
        'Luna Verduistering_Schwarz #21': '//www.norsemaison.com/cdn/shop/files/Luna-21.jpg?v=1772454945',

        // Eclipse Verduistering
        'Eclipse Verduistering_Wit': '//www.norsemaison.com/cdn/shop/files/Eclipse-100-Blackout.jpg?v=1772454945',
        'Eclipse Verduistering_White': '//www.norsemaison.com/cdn/shop/files/Eclipse-100-Blackout.jpg?v=1772454945',
        'Eclipse Verduistering_Blanc': '//www.norsemaison.com/cdn/shop/files/Eclipse-100-Blackout.jpg?v=1772454945',
        'Eclipse Verduistering_Weiß': '//www.norsemaison.com/cdn/shop/files/Eclipse-100-Blackout.jpg?v=1772454945',
        'Eclipse Verduistering_Bianco': '//www.norsemaison.com/cdn/shop/files/Eclipse-100-Blackout.jpg?v=1772454945',
        'Eclipse Verduistering_Blanco': '//www.norsemaison.com/cdn/shop/files/Eclipse-100-Blackout.jpg?v=1772454945',
    };

    // Inject CSS for square images
    const style = document.createElement('style');
    style.textContent = `
        .product-gallery__media img {
            aspect-ratio: 1 / 1 !important;
            object-fit: cover !important;
            width: 100% !important;
            height: 100% !important;
        }
    `;
    document.head.appendChild(style);

    // Helper functions
    function getSelectedFabricCollection() {
        const checkedRadio = document.querySelector('.fabric-collection input[type="radio"]:checked');
        if (checkedRadio) {
            const label = checkedRadio.closest('.mw-option__value');
            if (label) {
                const titleElement = label.querySelector('.mw-option__value-text');
                if (titleElement) {
                    return titleElement.textContent.trim();
                }
            }
        }
        return null;
    }

    function getSelectedSwatch() {
        const swatchGroups = document.querySelectorAll('.mw-group:not(.mw-group__hidden)');
        
        for (const group of swatchGroups) {
            const isBlackoutGroup = group.querySelector('.mw-option--type-choicetile') !== null;
            if (isBlackoutGroup) continue;
            
            const checkedSwatch = group.querySelector('.mw-option--type-swatch:not(.mw-hidden) input[type="radio"]:checked');
            if (checkedSwatch) {
                const swatchContainer = checkedSwatch.closest('.mw-option__value');
                if (swatchContainer) {
                    const titleElement = swatchContainer.querySelector('.mw-option__value-text');
                    if (titleElement) {
                        return titleElement.textContent.trim();
                    }
                }
            }
        }
        return null;
    }

    function isSwatchSelected() {
        const swatchGroups = document.querySelectorAll('.mw-group:not(.mw-group__hidden)');
        
        for (const group of swatchGroups) {
            const isBlackoutGroup = group.querySelector('.mw-option--type-choicetile') !== null;
            if (isBlackoutGroup) continue;
            
            const swatchOption = group.querySelector('.mw-option--type-swatch:not(.mw-hidden)');
            if (swatchOption) {
                const checkedRadio = swatchOption.querySelector('input[type="radio"]:checked');
                if (checkedRadio) {
                    return true;
                }
            }
        }
        return false;
    }

    function getSwatchImage(fabricCollection, swatchText) {
        if (!swatchText) return null;
        
        if (fabricCollection) {
            const key = fabricCollection + '_' + swatchText;
            if (secondImageReplacementMap[key]) {
                return secondImageReplacementMap[key];
            }
        }
        
        if (secondImageReplacementMap[swatchText]) {
            return secondImageReplacementMap[swatchText];
        }
        
        return null;
    }

    function getFirstImageReplacement(swatchText, fabricCollection) {
        if (!swatchText || !fabricCollection) return null;
        
        const key = fabricCollection + '_' + swatchText;
        if (firstImageReplacementMap[key]) {
            return firstImageReplacementMap[key];
        }
        
        return null;
    }

    function getSecondImageReplacement(swatchText, fabricCollection) {
        if (!swatchText || !fabricCollection) return null;
        
        const key = fabricCollection + '_' + swatchText;
        if (secondImageReplacementMap[key]) {
            return secondImageReplacementMap[key];
        }
        
        return null;
    }

    // Track current state to avoid unnecessary updates
    let currentState = {
        swatchSelected: false,
        swatchText: null,
        fabricCollection: null,
        isUpdating: false
    };

    function resetGallery() {
        const mediaElements = gallery.querySelectorAll(".product-gallery__media");
        const thumbnailElements = document.querySelectorAll(".product-gallery__thumbnail");
        const pageDots = document.querySelector("page-dots");

        // Reset first image
        const firstMediaEl = mediaElements[0];
        if (firstMediaEl) {
            const firstImg = firstMediaEl.querySelector("img");
            if (firstImg) {
                firstImg.src = originalSrc;
                firstImg.srcset = originalSrc;
            }
        }

        // Reset all media elements display
        mediaElements.forEach((media) => {
            media.style.display = "";
            media.style.visibility = "";
        });

        // Reset second image
        if (secondMediaElement && secondImageOriginalSrc) {
            const img = secondMediaElement.querySelector("img");
            if (img) {
                img.src = secondImageOriginalSrc;
                img.srcset = secondImageOriginalSrc;
            }
        }

        // Reset thumbnails - restore original images and display
        thumbnailElements.forEach((thumb, index) => {
            const img = thumb.querySelector("img");
            if (img && thumbnailOriginalSrcs[index]) {
                img.src = thumbnailOriginalSrcs[index];
                img.srcset = thumbnailOriginalSrcs[index];
            }
            thumb.style.display = "";
            thumb.style.visibility = "";
        });

        // Reset page dots
        if (pageDots) {
            const dotButtons = pageDots.querySelectorAll('button');
            dotButtons.forEach((dot) => {
                dot.style.display = "";
                dot.style.visibility = "";
            });
        }
        
        // Reset state
        currentState.swatchSelected = false;
        currentState.swatchText = null;
        currentState.fabricCollection = null;
    }

    function updateGallery() {
        // Prevent concurrent updates
        if (currentState.isUpdating) return;
        currentState.isUpdating = true;

        try {
            const swatchSelected = isSwatchSelected();
            const swatchText = getSelectedSwatch();
            const fabricCollection = getSelectedFabricCollection();
            
            // Check if state actually changed
            const stateChanged = 
                currentState.swatchSelected !== swatchSelected ||
                currentState.swatchText !== swatchText ||
                currentState.fabricCollection !== fabricCollection;
            
            if (!stateChanged) {
                currentState.isUpdating = false;
                return;
            }
            
            // Update current state
            currentState.swatchSelected = swatchSelected;
            currentState.swatchText = swatchText;
            currentState.fabricCollection = fabricCollection;
            
            if (!swatchSelected) {
                resetGallery();
                currentState.isUpdating = false;
                return;
            }

            const firstImageToUse = getFirstImageReplacement(swatchText, fabricCollection);
            const secondImageToUse = getSecondImageReplacement(swatchText, fabricCollection) || getSwatchImage(fabricCollection, swatchText);
            
            // Determine if we should show one or two images
            const showTwoImages = !!firstImageToUse;
            
            const mediaElements = gallery.querySelectorAll(".product-gallery__media");
            const thumbnailElements = document.querySelectorAll(".product-gallery__thumbnail");
            const pageDots = document.querySelector("page-dots");

            // Update first image
            const firstMediaEl = mediaElements[0];
            if (firstMediaEl) {
                const firstImg = firstMediaEl.querySelector("img");
                if (firstImg) {
                    if (firstImageToUse) {
                        firstImg.src = firstImageToUse;
                        firstImg.srcset = firstImageToUse;
                    } else if (secondImageToUse) {
                        firstImg.src = secondImageToUse;
                        firstImg.srcset = secondImageToUse;
                    } else {
                        firstImg.src = originalSrc;
                        firstImg.srcset = originalSrc;
                    }
                }
            }

            // Update second image if we're showing two images
            if (showTwoImages && mediaElements.length > 1) {
                const secondMediaEl = mediaElements[1];
                const secondImg = secondMediaEl.querySelector("img");
                if (secondImg) {
                    if (secondImageToUse) {
                        secondImg.src = secondImageToUse;
                        secondImg.srcset = secondImageToUse;
                    } else {
                        secondImg.src = secondImageOriginalSrc;
                        secondImg.srcset = secondImageOriginalSrc;
                    }
                }
            }

            // Update thumbnails
            if (thumbnailElements.length > 0) {
                const firstThumb = thumbnailElements[0];
                const firstThumbImg = firstThumb ? firstThumb.querySelector("img") : null;
                if (firstThumbImg) {
                    if (firstImageToUse) {
                        firstThumbImg.src = firstImageToUse;
                        firstThumbImg.srcset = firstImageToUse;
                    } else if (secondImageToUse) {
                        firstThumbImg.src = secondImageToUse;
                        firstThumbImg.srcset = secondImageToUse;
                    } else {
                        firstThumbImg.src = originalSrc;
                        firstThumbImg.srcset = originalSrc;
                    }
                }
            }

            if (showTwoImages && thumbnailElements.length > 1) {
                const secondThumb = thumbnailElements[1];
                const secondThumbImg = secondThumb ? secondThumb.querySelector("img") : null;
                if (secondThumbImg) {
                    if (secondImageToUse) {
                        secondThumbImg.src = secondImageToUse;
                        secondThumbImg.srcset = secondImageToUse;
                    } else {
                        secondThumbImg.src = secondImageOriginalSrc;
                        secondThumbImg.srcset = secondImageOriginalSrc;
                    }
                }
            }

            // Handle media elements - show only what we need
            const mediaCountToShow = showTwoImages ? 2 : 1;
            mediaElements.forEach((media, index) => {
                if (index < mediaCountToShow) {
                    media.style.display = "";
                    media.style.visibility = "";
                } else {
                    media.style.display = "none";
                    media.style.visibility = "hidden";
                }
            });

            // Handle thumbnails - show only what we need
            const thumbCountToShow = showTwoImages ? 2 : 1;
            thumbnailElements.forEach((thumb, index) => {
                if (index < thumbCountToShow) {
                    thumb.style.display = "";
                    thumb.style.visibility = "";
                } else {
                    thumb.style.display = "none";
                    thumb.style.visibility = "hidden";
                }
            });

            // Handle page dots - show only what we need
            if (pageDots) {
                const dotButtons = pageDots.querySelectorAll('button');
                dotButtons.forEach((dot, index) => {
                    if (index < thumbCountToShow) {
                        dot.style.display = "";
                        dot.style.visibility = "";
                    } else {
                        dot.style.display = "none";
                        dot.style.visibility = "hidden";
                    }
                });
            }
        } catch (error) {
            console.log("Gallery update error:", error);
        } finally {
            currentState.isUpdating = false;
        }
    }

    let timeoutId = null;
    const debouncedUpdate = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            updateGallery();
            timeoutId = null;
        }, 100);
    };

    // Single change listener for radio buttons
    document.addEventListener('change', function(e) {
        const target = e.target;
        if (target && target.type === 'radio') {
            const isSwatchRadio = target.closest('.mw-option--type-swatch');
            const isFabricRadio = target.closest('.fabric-collection');
            
            if (isSwatchRadio || isFabricRadio) {
                // Reset gallery first to prevent conflicts
                resetGallery();
                // Then update after a short delay
                setTimeout(debouncedUpdate, 200);
            }
        }
    });

    // Click listener for swatch containers - only if not handled by change event
    document.addEventListener('click', function(e) {
        const target = e.target;
        const swatchContainer = target.closest('.mw-option__value.mw-option__value--has-title');
        if (swatchContainer) {
            const isSwatch = swatchContainer.closest('.mw-option--type-swatch');
            if (isSwatch) {
                setTimeout(debouncedUpdate, 150);
            }
        }
    });

    // REMOVED: The problematic IntersectionObserver that was causing resets on scroll
    // Instead, use a MutationObserver that only watches for class changes on specific elements
    // that are relevant to the gallery functionality
    
    // Only observe changes to the specific elements that affect the gallery
    const galleryObserver = new MutationObserver((mutations) => {
        // Check if any mutation affects the swatch or fabric selection state
        let shouldUpdate = false;
        
        for (const mutation of mutations) {
            // Only process class changes and attribute changes
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const target = mutation.target;
                
                // Check if the element is relevant to our gallery
                const isRelevant = 
                    target.classList.contains('mw-group') ||
                    target.classList.contains('mw-option--type-swatch') ||
                    target.classList.contains('mw-option__value') ||
                    target.classList.contains('mw-option__value-text') ||
                    target.closest('.fabric-collection');
                
                if (isRelevant) {
                    // Check if the change is about visibility (hidden class)
                    const oldClassList = mutation.oldValue ? mutation.oldValue.split(' ') : [];
                    const newClassList = target.className.split(' ');
                    
                    const wasHidden = oldClassList.includes('mw-hidden') || oldClassList.includes('mw-group__hidden');
                    const isHidden = newClassList.includes('mw-hidden') || newClassList.includes('mw-group__hidden');
                    
                    if (wasHidden !== isHidden) {
                        shouldUpdate = true;
                        break;
                    }
                }
            }
        }
        
        if (shouldUpdate && isSwatchSelected()) {
            setTimeout(debouncedUpdate, 200);
        }
    });

    // Observe all relevant elements with old value to detect changes
    document.querySelectorAll('.mw-group, .mw-option--type-swatch, .mw-option__value, .fabric-collection').forEach(el => {
        galleryObserver.observe(el, {
            attributes: true,
            attributeFilter: ['class'],
            attributeOldValue: true
        });
    });

    // Listen for next/back button clicks
    document.addEventListener('click', function(e) {
        const target = e.target;
        const isNextButton = target.closest('.mw-group__button-next');
        const isBackButton = target.closest('.mw-group__button-back');
        
        if (isNextButton || isBackButton) {
            resetGallery();
            setTimeout(debouncedUpdate, 300);
        }
    });

    // Initial update
    setTimeout(updateGallery, 500);
});